// extracted by mini-css-extract-plugin
module.exports = {"component":"popup_component__mojIl","close":"popup_close__JtfLu","content":"popup_content__1e-Mk","indexing":"popup_indexing___AJRq"};